import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NoficationsList from './NotificationsList';

export default class NotificationsPopover extends Component {
  static propTypes = {
    apiUrl: PropTypes.string.isRequired,
    viewAllUrl: PropTypes.string.isRequired,
    clicksUrl: PropTypes.string.isRequired,
    linkClicksUrl: PropTypes.string.isRequired,
    viewsUrl: PropTypes.string.isRequired,
    settingsUrl: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  openMenu = () => {
    this.setState({ open: true });
  }

  closeMenu = () => {
    this.setState({ open: false });
  }

  handleMarkAllAsRead = () => {
    $(document).trigger('notifications-mark-all-as-read');
  }

  componentDidMount() {
    $(document).on('announcement-menu', (e, open) => {
      if (open) this.openMenu();
      else this.closeMenu();
    });
  }

  componentWillUnmount() {
    $(document).off('announcement-menu');
  }

  render() {
    const openModifier = this.state.open ? 'Popover--open' : '';
    const classNames = ['u-fixed u-bg-black u-w-full u-h-full u-inset-0 u-opacity-30 lg:u-hidden'];
    if (this.state.open) {
      classNames.push("u-block");
    } else {
      classNames.push("u-hidden");
    }

    return (
      <div>
        <div className={classNames.join(" ")} onClick={this.closeMenu} />
        <div className={`Popover animated bounceIn ${openModifier}`}>
        <div className="Popover-header u-flex u-justify-between u-px-3 u-py-2 u-bg-white u-text-sm u-border-b">
          <strong>Notifications</strong>
          <div>
            <a className="u-mr-2 u-cursor-pointer" onClick={this.handleMarkAllAsRead}>Mark all as read</a>
            <a href={this.props.settingsUrl}>Settings</a>
          </div>
        </div>
        <div className="Popover-list">
          { this.state.open &&
          <NoficationsList {...this.props} scrollListener=".Popover-list" perPage={10} />
          }
        </div>
        <div className="Popover-footer u-flex u-justify-center u-px-3 u-py-2 u-bg-white u-text-sm u-border-t">
          <strong><a href={this.props.viewAllUrl}>See All</a></strong>
        </div>
      </div>
      </div>
    );
  }
}
